module.exports = __webpack_public_path__ + "media/blueDotAnimation.1aeccb20.mp4";